import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';

import { Tabs, Tab } from "./tabs/Tabs";

import Percy from './Percy';
import ProgressBar from './ProgressBar';
import Products from './Products';
import Vr from './Vr';
import Swag from './Swag';


const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  & div {
    width: 100%;
  }
`;

const BotBtn = styled.div`
  background: #93D500;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-around;

  & button {
    margin-top: 16px;
    border-radius: 50px;
    margin-bottom: 80px;
    background-color: #EF5196;
    font-weight: bolder;
    color: #000;
  }
`;


const App = () => {
  const [health, setHealth] = useState(0)
  const [hunger, setHunger] = useState(0)
  useEffect(() => {
    fetch("https://arcane-caverns-09499.herokuapp.com/get-user/apurv")
      .then(response => response.json())
      .then(data => {
        console.log(data);
        setHealth(data['percy']['health']);
        setHunger(data['percy']['hunger']);
      });
  });
  return (
    <Content><Tabs>
      <Tab label="Percy" key={0}>
        <Percy />
        <table style={{ padding: "0 5px 0 5px", background: '#93D500' }}>
          <tbody>
            <ProgressBar isHealth={true} bgcolor="red" completed={health} />
            <ProgressBar isHealth={false} bgcolor="brown" completed={100 - hunger} />
          </tbody>
        </table>
        <BotBtn>
          <button>Pet</button>
          <button>Feed</button>
        </BotBtn>
      </Tab>
      <Tab label="Shop" key={1}>
        <Products />
      </Tab>
      <Tab label="AR" key={2}>
        <Vr />
      </Tab>
      <Tab label="Swag" key={3}>
        <Swag />
      </Tab>
      </Tabs></Content>
  );
}

export default App;
